import React, { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as Close } from "assets/svgs/close.svg";
import NextDeliveryDate from "components/next-delivery-date";
import Money from "components/money";
import CartProgress from "components/cart/progress";
import { findClosestBox } from "utils/cart";
import { useGlobalContext } from "context/global";
import { TOGGLE_SUBS_CART, UPDATE_SUBSCRIPTION_BOX } from "utils/action-types";
import CartBoxSelector from "components/cart/box-selector";

const SubscriptionCartHeader = ({ shouldKeepCartOpen = false }) => {
	const { totalWeight, activeBox } = useSelector(state => state.account.subscription);
	const { translation, cartSettings: { boxes }, langCode } = useGlobalContext();
	const dispatch = useDispatch();

	const minBox = useMemo(() => findClosestBox(boxes, totalWeight), [boxes, totalWeight]);

	const handleClose = () => {
		dispatch({ type: TOGGLE_SUBS_CART });
	};

	return (
		<div className="sticky top-0 z-10 bg-white px-4 pt-2 w-full">
			{<div className="flex justify-between items-center mb-4">
				<NextDeliveryDate className="border-none pl-0 md:text-body" callback={handleClose} />
				<button onClick={() => !shouldKeepCartOpen && handleClose()}>
					<Close className="w-4 h-4" />
				</button>
			</div>}
			<div className="flex justify-between items-center pb-1">
				<strong className="text-sm tracking-wider font-base font-medium uppercase max-w-[60%]">
					{translation?.subscription?.cart?.title} ({totalWeight})
				</strong>
				<a href={`#boxsizes-popup${langCode === "en" ? "-en" : ""}`}
					className="text-secondary text-sm underline hidden lg:block">
					{translation.subscription?.cart?.show_box_sizes}
				</a>
				<div className="flex text-sm justify-end items-center flex-wrap lg:hidden">
					<span className="font-black whitespace-nowrap">
						<Money value={activeBox?.price} />{" "}/
					</span>
					<span className="text-secondary text-sm">{translation.cart?.meal}</span>
				</div>
			</div>
			<CartProgress totalProgress={totalWeight} box={activeBox} className="!mt-0" />
			{<CartBoxSelector
				activeBox={activeBox}
				minBoxSize={minBox.size.value}
				onBoxClick={(box) => dispatch({ type: UPDATE_SUBSCRIPTION_BOX, payload: { ...box, userSelected: true } })}
			/>}
		</div>
	);
};

export default SubscriptionCartHeader;